import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex gap-4 mb-6 items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold" }, "Factures", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Nouvelle facture")
const _hoisted_4 = { id: "invoice-list" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "inline-infos header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Numéro"),
  /*#__PURE__*/_createElementVNode("div", null, "Date de facturation"),
  /*#__PURE__*/_createElementVNode("div", null, "Logement"),
  /*#__PURE__*/_createElementVNode("div", null, "Email client"),
  /*#__PURE__*/_createElementVNode("div", { class: "actions" }, "Actions")
], -1)
const _hoisted_10 = { class: "space-y-2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Régénérer le PDF")
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Voir le PDF")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "Envoyer par Email", -1)
const _hoisted_16 = { class: "flex gap-2" }
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Envoyer")
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Générer le PDF")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JbButton = _resolveComponent("JbButton")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_JbAlert = _resolveComponent("JbAlert")!
  const _component_JbPanel = _resolveComponent("JbPanel")!
  const _component_JbPanelListRow = _resolveComponent("JbPanelListRow")!
  const _component_JbPanelList = _resolveComponent("JbPanelList")!
  const _component_InvoiceUpdateModal = _resolveComponent("InvoiceUpdateModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createVNode(_component_JbButton, {
          bg: "bg-sky-500 hover:bg-sky-400",
          text: "text-white",
          "icon-left": "plus",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitter.emit('open-modal-invoice-create')))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_JbPanel, {
      title: "Batch download",
      icon: "calendar-alt",
      class: "mb-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DatePicker, {
          style: {"display":"inline"},
          modelValue: _ctx.invoiceBatchListPaging.start,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.invoiceBatchListPaging.start) = $event))
        }, {
          default: _withCtx(({ inputValue, togglePopover }) => [
            _createVNode(_component_JbButton, {
              color: "lime",
              size: "l",
              onClick: ($event: any) => (togglePopover())
            }, {
              default: _withCtx(() => [
                _createTextVNode("Du " + _toDisplayString(inputValue), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("span", null, [
          _createVNode(_component_font_awesome_icon, { icon: "arrow-right" })
        ]),
        _createVNode(_component_DatePicker, {
          style: {"display":"inline"},
          modelValue: _ctx.invoiceBatchListPaging.limit,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.invoiceBatchListPaging.limit) = $event))
        }, {
          default: _withCtx(({ inputValue, togglePopover }) => [
            _createVNode(_component_JbButton, {
              color: "lime",
              size: "l",
              onClick: ($event: any) => (togglePopover())
            }, {
              default: _withCtx(() => [
                _createTextVNode("Au " + _toDisplayString(inputValue), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", null, [
          (_ctx.invoiceBatch)
            ? (_openBlock(), _createBlock(_component_JbAlert, {
                key: 0,
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.buttonSentence), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceBatch, (invoice) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: invoice }, [
              (invoice.file && invoice.file.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("a", {
                      href: _ctx.$ContentManagerUrl+invoice.file[0].url
                    }, [
                      _createVNode(_component_JbButton, {
                        class: "highlighted",
                        "icon-left": "download"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.invoiceHelpers.getNumber(invoice)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_6)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_JbPanel, {
        title: "Factures",
        width: "8",
        icon: "file-invoice-dollar",
        class: "mb-4"
      }, {
        default: _withCtx(() => [
          (_ctx.getInvoicesError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Error: " + _toDisplayString(_ctx.getInvoicesError.message), 1))
            : _createCommentVNode("", true),
          (_ctx.invoices)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_JbPanelList, {
                  display: "grid",
                  class: _normalizeClass(_ctx.getInvoicesLoading ? 'fetch-loading' : ''),
                  pagination: true,
                  pagingVar: _ctx.invoiceListPaging,
                  onUpdateStart: _cache[3] || (_cache[3] = ($event: any) => (_ctx.invoiceListPaging.start = $event))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice) => {
                      return (_openBlock(), _createBlock(_component_JbPanelListRow, {
                        key: invoice.id,
                        editable: "",
                        "item-id": invoice.id,
                        onEditElement: ($event: any) => (_ctx.setupEditModal(invoice.id))
                      }, {
                        "inline-infos": _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.invoiceHelpers.getNumber(invoice.attributes)), 1),
                          _createElementVNode("div", null, _toDisplayString(invoice.attributes.date), 1),
                          _createElementVNode("div", null, _toDisplayString(invoice.attributes.reservation.data ? invoice.attributes.reservation.data.attributes.bien.data.attributes.name : 'Aucun'), 1),
                          _createElementVNode("div", null, _toDisplayString(invoice.attributes.reservation.data ? invoice.attributes.reservation.data.attributes.guest.email : 'Aucun'), 1)
                        ]),
                        "all-infos": _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_JbPanel, { title: "Fichier PDF" }, {
                              default: _withCtx(() => [
                                (invoice.attributes.file.data !== null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                      _createVNode(_component_JbButton, {
                                        onClick: ($event: any) => (_ctx.generateInvoice(invoice.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_12
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createElementVNode("a", {
                                        href: _ctx.$ContentManagerUrl+invoice.attributes.file.data.attributes.url
                                      }, [
                                        _createVNode(_component_JbButton, {
                                          bg: "bg-sky-500 hover:bg-sky-400",
                                          text: "text-white",
                                          "icon-left": "eye"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_14
                                          ]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_13),
                                      _createElementVNode("div", null, [
                                        _hoisted_15,
                                        _createElementVNode("div", _hoisted_16, [
                                          _createElementVNode("input", {
                                            type: "text",
                                            class: "w-96",
                                            value: invoice.attributes.reservation.data ? invoice.attributes.reservation.data.attributes.guest.email : '' 
                                          }, null, 8, _hoisted_17),
                                          _createVNode(_component_JbButton, {
                                            bg: "bg-sky-500 hover:bg-sky-400",
                                            text: "text-white",
                                            onClick: ($event: any) => (_ctx.sendByEmailInvoice(invoice.id))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_18
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _createVNode(_component_JbButton, {
                                        bg: "bg-sky-500 hover:bg-sky-400",
                                        text: "text-white",
                                        onClick: ($event: any) => (_ctx.generateInvoice(invoice.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_20
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]))
                              ]),
                              _: 2
                            }, 1024),
                            (invoice.reservation)
                              ? (_openBlock(), _createBlock(_component_JbPanel, {
                                  key: 0,
                                  title: "Infos de la réservation"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", null, "Numéro : " + _toDisplayString(invoice.reservation.lodgify_id), 1),
                                    _createElementVNode("p", null, "Bien : " + _toDisplayString(invoice.reservation.bien.name), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["item-id", "onEditElement"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["class", "pagingVar"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_InvoiceUpdateModal, {
      elementId: _ctx.updateId,
      listPaging: _ctx.invoiceListPaging
    }, null, 8, ["elementId", "listPaging"])
  ]))
}